import { useCallback, useEffect, useRef, useState } from "react";

// Cancellable countdown (e.g. 30 s) that fires `onFire` when it reaches zero.
export function useCountdownAction(onFire, seconds = 30) {
  const [countdown, setCountdown] = useState(null);
  const timer = useRef(null);
  const fireRef = useRef(onFire);
  fireRef.current = onFire;

  const stop = useCallback(() => {
    if (timer.current) { clearInterval(timer.current); timer.current = null; }
  }, []);
  const cancel = useCallback(() => { stop(); setCountdown(null); }, [stop]);
  const start = useCallback(() => {
    setCountdown(seconds);
    timer.current = setInterval(() => setCountdown((c) => (c > 0 ? c - 1 : 0)), 1000);
  }, [seconds]);

  useEffect(() => {
    if (countdown === 0) { stop(); fireRef.current(); }
  }, [countdown, stop]);
  useEffect(() => stop, [stop]);

  return { countdown, start, cancel, running: countdown !== null };
}
